<template>
    <div id="AddProducerData">
      <AddProducer :data="is_admin_dealer" />
    </div>
  </template>
  
  <script>
  import Vue from "vue";
  import AddProducer from "../producer/AddProducer.vue"
  
  
  export default {
    name: "AddProducerData",
    created() {
      
    },
    data() {
      return {
        is_admin_dealer:1
      };
    },
    components: {
      AddProducer
    },
   
    methods: {
     
    },
   
  };
  </script>
  
  <style scoped>
  
  </style>